import classNames from "classnames";
import React from "react";
import BranchLink from "web/react/components/branch-link/branch-link";
import { gettext } from "web/script/modules/django-i18n";
import { RawBranchLink } from "web/script/utils/branch-io";
import styles from "./app-download-badge.css";

type AppButtonType = "white" | "black";
type AppDownloadLink = "footer" | "appPage" | "appTeaser";

const APP_DOWNLOAD_LINKS: { readonly [lnk in AppDownloadLink]: RawBranchLink } = {
    footer: RawBranchLink.Footer,
    appPage: RawBranchLink.AppPage,
    appTeaser: RawBranchLink.AppTeaser,
};

interface AppDownloadButtonProps {
    color: AppButtonType;
    appDownloadLink: AppDownloadLink;
    eventLabel: string;
    titleId?: string;
    isBadge?: boolean;
    small?: boolean;
}

export function AppDownloadBadge({
    color,
    small,
    appDownloadLink,
    eventLabel,
    titleId,
}: AppDownloadButtonProps): JSX.Element {
    let title = "";
    if (titleId) {
        title = gettext(titleId);
    }
    const branchLink = APP_DOWNLOAD_LINKS[appDownloadLink];
    return (
        <BranchLink
            className={classNames(styles.badge, {
                [styles.black]: color == "black",
                [styles.white]: color == "white",
                [styles.small]: small,
            })}
            branchLink={branchLink}
            eventLabel={eventLabel}
            title={title}
        />
    );
}

export default AppDownloadBadge;
